<template>
  <div class="login_page">
    <div class="login_page_wrapper">
      <form>
        <div class="header">
          <img src="/SotaExLogo.svg" alt="logo_monas" />
          <h3>Login Admin</h3>
        </div>
        <div class="form-group">
          <input
            type="text"
            name="email"
            v-model="email"
            autocomplete="off"
            readonly
            @focus="$event.target.removeAttribute('readonly')"
            :placeholder="$t('login.email2')"
            :class="{ 'input-error': emailError }"
            :maxlength="100"
          />
          <span v-if="emailError" class="error-message">{{ emailError }}</span>
        </div>
        <div class="form-group">
          <div class="password-input-wrapper">
            <input
              :type="showPassword ? 'text' : 'password'"
              name="password"
              autocomplete="new-password"
              readonly
              @focus="$event.target.removeAttribute('readonly')"
              v-model="password"
              :placeholder="$t('common.placeholders.password')"
              :class="{ 'input-error': passwordError }"
              :maxlength="100"
            />
            <button
              type="button"
              class="toggle-password"
              @click="showPassword = !showPassword"
            >
              <img
                v-if="showPassword"
                src="@/assets/icons/eye-open.svg"
                alt="Hide password"
              />
              <img
                v-else
                src="@/assets/icons/eye-closed.svg"
                alt="Show password"
              />
            </button>
          </div>
          <span v-if="passwordError" class="error-message">{{
            passwordError
          }}</span>
        </div>
        <BaseButton @click="login" type="button" class="btn-login">{{
          $t("login.title")
        }}</BaseButton>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BaseButton from "../common/Button.vue";
export default {
  name: "Login",
  components: {
    BaseButton,
  },
  data() {
    return {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      showPassword: false,
    };
  },

  methods: {
    login() {
      this.emailError = "";
      this.passwordError = "";

      const domain = process.env.VUE_APP_API_URL;
      axios
        .post(domain + "/auth/login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          localStorage.setItem("token", response.data.access_token);
          window.axios.defaults.headers.common["Authorization"] =
            response.data.token_type + " " + response.data.access_token;
          window.location.href = "/admin/orders/open-order";
        })
        .catch((error) => {
          if (!error.response) {
            // Server error (CORS / network / server down)
            this.$toastr('error', 'Server error');
            return;
          }
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            const messages = error.response.data.message;
            if (Array.isArray(messages)) {
              messages.forEach((msg) => {
                if (msg.toLowerCase().includes("email")) {
                  this.emailError = msg;
                } else if (msg.toLowerCase().includes("password")) {
                  this.passwordError = msg;
                }
              });
            } else if (typeof messages === "string") {
              this.passwordError = messages;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login_page {
  background: #191f2b;
  .login_page_wrapper {
    width: 100%;
    height: 100vh;
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    form {
      width: 100%;
      background: #c3fe4c;
      padding: 20px;
      border-radius: 10px;
      .header {
        text-align: center;
        img {
          height: 50px;
          width: auto;
          margin-top: 15px;
        }
        h3 {
          color: #000;
          font-size: 20px;
          line-height: 30px;
          margin: 15px 0;
        }
      }
      .form-group {
        margin-bottom: 15px;
      }
      .password-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
      }
      input {
        width: 100%;
        height: auto;
        font-size: 16px;
        border: 1px solid #c7cbd3;
        border-radius: 5px;
        padding: 10px;
        &:focus {
          outline: none;
        }
        &.input-error {
          border-color: #ff4444;
        }
      }
      .password-input-wrapper input {
        padding-right: 40px;
      }
      .toggle-password {
        position: absolute;
        right: 10px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:focus {
          outline: none;
        }
        img {
          width: 20px;
          height: 20px;
          display: block;
        }
      }
      .error-message {
        display: block;
        color: #ff4444;
        font-size: 12px;
        margin-top: 5px;
      }
      .btn-login {
        width: 100%;
        background-color: #000000;
      }
    }
  }
}
</style>
